export class FreeInsuranceRequest {
    public retailerCode: string;
    public saleDate: string;
    public handoverDate: string;
    public vin: string;
    public vrn: string;
    public email: string;
    public consent: boolean;
    public newVehicle?: boolean;
}
